import React from 'react';
import { string } from 'prop-types';

const useEpgItemTime = ({ till, since }) => {
	const [isLive, setIsLive] = React.useState(true);
	const [isUpcoming, setUpcoming] = React.useState(true);
	const [isNotEnded, setNotEnded] = React.useState(false);

	React.useEffect(() => {
		const currentTime = new Date().getTime();
		const start = new Date(since.replace(/-/g, '/')).getTime();
		const end = new Date(till.replace(/-/g, '/')).getTime();
		// Check if current program is live now
		start < currentTime && end > currentTime
			? setIsLive(true)
			: setIsLive(false);
		// Check if current program is upcoming
		start > currentTime ? setUpcoming(true) : setUpcoming(false);
		// Check if current program is not ended
		end > currentTime ? setNotEnded(true) : setNotEnded(false);
	}, [since, till]);
	return { isLive, isUpcoming, isNotEnded };
};

useEpgItemTime.propTypes = {
	till: string.isRequired,
	since: string.isRequired
};

export default useEpgItemTime;
